/**
 * @generated SignedSource<<425f51c050ca3a50e25a5f58a4f2fd4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DiscardReportDraftInput = {
  reportId?: string | null;
  lockToken?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DiscardReportDraftMutation$variables = {
  input: DiscardReportDraftInput;
};
export type DiscardReportDraftMutation$data = {
  readonly discardReportDraft: {
    readonly draftState: string | null;
    readonly publishedAt: string | null;
    readonly locked: boolean | null;
    readonly draftFilterWillRevert: boolean | null;
  } | null;
};
export type DiscardReportDraftMutation = {
  variables: DiscardReportDraftMutation$variables;
  response: DiscardReportDraftMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DiscardReportDraftPayload",
    "kind": "LinkedField",
    "name": "discardReportDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftFilterWillRevert",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscardReportDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscardReportDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2e3665f4446abf4061d224e34d7279e",
    "id": null,
    "metadata": {},
    "name": "DiscardReportDraftMutation",
    "operationKind": "mutation",
    "text": "mutation DiscardReportDraftMutation(\n  $input: DiscardReportDraftInput!\n) {\n  discardReportDraft(input: $input) {\n    draftState\n    publishedAt\n    locked\n    draftFilterWillRevert\n  }\n}\n"
  }
};
})();

(node as any).hash = "177784ef0c707971e10d21bb4e44f935";

export default node;
